export function environmentEvidence(metadata = {}, hostname = "") {
  const env = metadata.environment;
  const previewHost = /(^|\.)preview\.emergentagent\.com$/.test(hostname)
    || ["localhost", "127.0.0.1"].includes(hostname);
  if (previewHost && ["preview", "test", "local"].includes(env)) {
    return { environment: env, label: "VORSCHAU", tone: "amber" };
  }
  if (hostname === "app.kewagpage.ch" && env === "production") {
    return { environment: "production", label: "PRODUKTION", tone: "green" };
  }
  return { environment: "unknown", label: "UMGEBUNG UNGEPRÜFT", tone: "amber" };
}

export function websiteReachabilityVerified(site = {}, now = Date.now()) {
  if (site.states?.reachability?.color !== "green") return false;
  const timestamp = site.data_source === "live" ? site.last_checked
    : site.data_source === "connector" && site.connector_connected ? site.connector_checked_at : null;
  const checked = Date.parse(timestamp || "");
  const age = now - checked;
  return Number.isFinite(checked) && age >= -5 * 60 * 1000 && age <= 7 * 60 * 60 * 1000;
}
